import t from "./index49.js";
import u from "./index60.js";
import O from "./index71.js";
import y from "./index59.js";
import N from "./index72.js";
import S from "./index73.js";
import g from "./index54.js";
const f = (e, r) => e != null && t.hasOwnProp(e, r) ? e[r] : void 0;
function F(e, r, n) {
  if (t.isString(e))
    try {
      return (r || JSON.parse)(e), t.trim(e);
    } catch (i) {
      if (i.name !== "SyntaxError")
        throw i;
    }
  return (n || JSON.stringify)(e);
}
const l = {
  transitional: O,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [
    function(r, n) {
      const i = n.getContentType() || "", m = i.indexOf("application/json") > -1, o = t.isObject(r);
      if (o && t.isHTMLForm(r) && (r = new FormData(r)), t.isFormData(r))
        return m ? JSON.stringify(g(r)) : r;
      if (t.isArrayBuffer(r) || t.isBuffer(r) || t.isStream(r) || t.isFile(r) || t.isBlob(r) || t.isReadableStream(r))
        return r;
      if (t.isArrayBufferView(r))
        return r.buffer;
      if (t.isURLSearchParams(r))
        return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), r.toString();
      let c;
      if (o) {
        const s = f(this, "formSerializer");
        if (i.indexOf("application/x-www-form-urlencoded") > -1)
          return N(r, s).toString();
        if ((c = t.isFileList(r)) || i.indexOf("multipart/form-data") > -1) {
          const p = f(this, "env"), a = p && p.FormData;
          return y(
            c ? { "files[]": r } : r,
            a && new a(),
            s
          );
        }
      }
      return o || m ? (n.setContentType("application/json", !1), F(r)) : r;
    }
  ],
  transformResponse: [
    function(r) {
      const n = f(this, "transitional") || l.transitional, i = n && n.forcedJSONParsing, m = f(this, "responseType"), o = m === "json";
      if (t.isResponse(r) || t.isReadableStream(r))
        return r;
      if (r && t.isString(r) && (i && !m || o)) {
        const c = !(n && n.silentJSONParsing) && o;
        try {
          return JSON.parse(r, f(this, "parseReviver"));
        } catch (s) {
          if (c)
            throw s.name === "SyntaxError" ? u.from(s, u.ERR_BAD_RESPONSE, this, null, f(this, "response")) : s;
        }
      }
      return r;
    }
  ],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: S.classes.FormData,
    Blob: S.classes.Blob
  },
  validateStatus: function(r) {
    return r >= 200 && r < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
t.forEach(["delete", "get", "head", "post", "put", "patch", "query"], (e) => {
  l.headers[e] = {};
});
const P = l;
export {
  P as default
};
